import Header from "@arelia-components/layout/Header";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { Button } from "@mui/material";
import CustomersPresenter from "./CustomersPresenter";
import { ApplicationPaths } from "@arelia-components/api-authorization/AuthConstants";
import { useHqCustomersAPI } from "./hq-customers.api";

export default function CustomersContainer() {
  const { data: customers, isLoading } = useHqCustomersAPI();
  let viewCustomers = customers?.map(c => ({
    ...c,
    displayName: c.band?.name || c.fullName || c.email
  })) || [];

  const action = <Button
    variant="contained"
    color="secondary"
    sx={{ marginLeft: "auto", width: "180px"}}
    href={ApplicationPaths.RegisterWithRedirect}
  >
    Add Customer
  </Button>

  return (
    <ContentBox>
      <Header
        title="Customers"
        action={action}
      />
      <SpinnerWrapper loading={isLoading}>
        <CustomersPresenter customers={viewCustomers || []} />
      </SpinnerWrapper>
    </ContentBox>
  );
}